"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSubmitPunchCTK = exports.useSubmitPunchNonCTK = exports.useSubmitPunch = void 0;
var react_1 = require("react");
var react_query_1 = require("react-query");
var atoz_shiftapp_utilities_1 = require("@amzn/atoz-shiftapp-utilities");
var fetchClient_1 = require("../../client/fetchClient");
var paths_1 = require("../../paths");
var DateManagement_1 = require("../../utils/DateManagement");
function useSubmitPunch(props) {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return props.ctkPolicy ? useSubmitPunchCTK() : useSubmitPunchNonCTK(props);
}
exports.useSubmitPunch = useSubmitPunch;
function useSubmitPunchNonCTK(_a) {
    var employeeId = _a.employeeId, siteId = _a.siteId, timeZone = _a.timeZone;
    var features = (0, atoz_shiftapp_utilities_1.useAssociateContext)().features;
    var _b = (0, react_query_1.useMutation)(fetchClient_1.submitData), loading = _b.isLoading, error = _b.error, mutate = _b.mutate;
    var _c = (0, react_1.useState)(''), data = _c[0], setData = _c[1];
    var _d = (0, react_1.useState)(), retryParams = _d[0], setRetryParams = _d[1];
    var submitPunch = function (punchTime, punchDate, useMilitaryTime) {
        setRetryParams(undefined);
        setData('');
        var punchDateTime = (0, DateManagement_1.parsePunchTime)(punchTime, punchDate, useMilitaryTime).toISO();
        mutate({
            path: (0, paths_1.SUBMIT_PUNCH_API)(employeeId || ''),
            method: 'POST',
            body: {
                isMissedPunchCorrection: true,
                isPunchValidationRequired: true,
                location: siteId || '',
                userTimeZone: timeZone || '',
                punchDateTime: punchDateTime
            },
            useTaaDashboardComponents: features.useTaaDashboardComponents
        }, {
            onSuccess: function () {
                setData(punchDateTime);
            },
            onError: function () {
                setRetryParams({
                    punchTime: punchTime,
                    punchDate: punchDate,
                    useMilitaryTime: useMilitaryTime
                });
            }
        });
    };
    var retry = function () {
        if (!retryParams || loading)
            return;
        var punchTime = retryParams.punchTime, punchDate = retryParams.punchDate, useMilitaryTime = retryParams.useMilitaryTime;
        submitPunch(punchTime, punchDate, useMilitaryTime);
    };
    return {
        submitPunchState: {
            data: data,
            loading: loading,
            error: retryParams ? error : undefined,
            retry: retry
        },
        submitPunch: submitPunch
    };
}
exports.useSubmitPunchNonCTK = useSubmitPunchNonCTK;
function useSubmitPunchCTK() {
    var _this = this;
    var features = (0, atoz_shiftapp_utilities_1.useAssociateContext)().features;
    var _a = (0, react_query_1.useMutation)(fetchClient_1.postESSData), loading = _a.isLoading, error = _a.error, mutate = _a.mutate;
    var _b = (0, react_1.useState)(''), data = _b[0], setData = _b[1];
    var _c = (0, react_1.useState)(), retryParams = _c[0], setRetryParams = _c[1];
    var submitPunch = function (punchTime, punchDate, useMilitaryTime) { return __awaiter(_this, void 0, void 0, function () {
        var ctkTime, punchDateString;
        return __generator(this, function (_a) {
            setRetryParams(undefined);
            setData('');
            ctkTime = useMilitaryTime
                ? punchTime
                : (0, DateManagement_1.convertTimeStringToMilitaryTimeString)(punchTime);
            punchDateString = punchDate.toJSDate().toDateString();
            mutate({
                path: (0, paths_1.SUBMIT_PUNCH_CTK_API)(),
                method: 'POST',
                body: {
                    missed_punch_ticket: {
                        date: punchDateString,
                        missed_punches: [ctkTime]
                    }
                },
                useTaaDashboardComponents: features.useTaaDashboardComponents
            }, {
                onSuccess: function () {
                    setData((0, DateManagement_1.parsePunchTime)(punchTime, punchDate, useMilitaryTime).toISO());
                },
                onError: function () {
                    setRetryParams({
                        punchTime: punchTime,
                        punchDate: punchDate,
                        useMilitaryTime: useMilitaryTime
                    });
                }
            });
            return [2 /*return*/];
        });
    }); };
    var retry = function () {
        if (!retryParams || loading)
            return;
        var punchTime = retryParams.punchTime, punchDate = retryParams.punchDate, useMilitaryTime = retryParams.useMilitaryTime;
        submitPunch(punchTime, punchDate, useMilitaryTime);
    };
    return {
        submitPunchState: {
            data: data,
            loading: loading,
            error: retryParams ? error : undefined,
            retry: retry
        },
        submitPunch: submitPunch
    };
}
exports.useSubmitPunchCTK = useSubmitPunchCTK;
